/*
 * @Copyright: 网易集成平台
 * @Author: xiaowenwen
 * @Date: 2021-12-20 11:47:52
 * @LastEditTime: 2022-03-29 15:26:08
 * @Description:邮箱账号列表
 */
import http, { formConfig } from "@/utils/http";
const url = action => `/sync/email/${action[0]}`;

export default class Emaillist {
  static LIST(params) {
    return http.get(url`list`, { params });
  }
  static Export(data) {
    return http.post(url`export`, data, formConfig);
  }
}
